import { MAX_TWO_FACTOR_SETTING_KEYS, SETTINGS_TYPES } from "@/constant";
import { settingApi } from "@/api";

// Храним состояние загрузки для каждого типа отдельно
const fetchingStatus = {
    [SETTINGS_TYPES.GENERAL]: false,
    [SETTINGS_TYPES.CUSTOM]: false,
    [SETTINGS_TYPES.MENU]: false,
    [SETTINGS_TYPES.CHILD_ACCOUNT]: false,
    [SETTINGS_TYPES.TEACHER_ACCOUNT]: false,
    [SETTINGS_TYPES.NOTIFICATIONS]: false,
    [SETTINGS_TYPES.PAYMENT]: false,
    [SETTINGS_TYPES.CRM]: false,
};

const isMaxTwoFactorSetting = (item) =>
    MAX_TWO_FACTOR_SETTING_KEYS.includes(item?.key);

const buildSettingsByType = (settings = [], type = SETTINGS_TYPES.GENERAL) => {
    const settingsByType = {};

    if (type === SETTINGS_TYPES.GENERAL) {
        settings
            .filter(item => item.type !== SETTINGS_TYPES.GENERAL && isMaxTwoFactorSetting(item))
            .forEach(item => Object.assign(settingsByType, { [item.key]: item.value }));
    }

    settings
        .filter(item => item.type === type)
        .forEach(item => Object.assign(settingsByType, { [item.key]: item.value }));

    return settingsByType;
};

const parseSettings = (storeData) => {
    try {
        return storeData ? JSON.parse(storeData) : null;
    } catch {
        return null;
    }
};

const shouldRefreshGeneralSettings = (type, settings) =>
    type === SETTINGS_TYPES.GENERAL &&
    (!settings || MAX_TWO_FACTOR_SETTING_KEYS.some(key => !(key in settings)));

export const SettingsService = {
    get: (type) => {
        const key = getKey(type);
        let storeData = localStorage.getItem(key);
        const cachedSettings = parseSettings(storeData);

        if (!storeData || shouldRefreshGeneralSettings(key, cachedSettings)) {
            settingApi.getAll()
                .then(response => {
                    const generalSettings = buildSettingsByType(response.data, type);
                    localStorage.setItem(key, JSON.stringify(generalSettings));
                });

            // If fetching from API, return the existing data from localStorage if available
            return cachedSettings;
        }

        // Return the data from localStorage
        return cachedSettings;
    },

    getCorrected: async (type) => {
        const key = type ?? SETTINGS_TYPES.GENERAL;
        
        let storeData = localStorage.getItem(key);
        const cachedSettings = parseSettings(storeData);
        if(storeData && !shouldRefreshGeneralSettings(key, cachedSettings)){
            return cachedSettings;
        }
        
        if (!fetchingStatus[key]) {
            fetchingStatus[key] = true;
            try {
                const response = await settingApi.getAll(); // Ожидаем выполнения API вызова
                const generalSettings = buildSettingsByType(response.data, type);
                localStorage.setItem(key, JSON.stringify(generalSettings));
                return generalSettings; // Возвращаем полученные настройки после загрузки
            } catch (error) {
                console.error('Ошибка при получении настроек:', error); // Обработка ошибки
                return null; // Возвращаем null в случае ошибки
            } finally {
                fetchingStatus[key] = false; // Сбрасываем флаг загрузки после завершения
            }
        }
        return null;

    },

};

const getKey = (type) => {
    let key;
    switch (type) {
        case SETTINGS_TYPES.GENERAL:
            key = SETTINGS_TYPES.GENERAL;
            break;
        case SETTINGS_TYPES.CUSTOM:
            key = SETTINGS_TYPES.CUSTOM;
            break;
        case SETTINGS_TYPES.PAYMENT:
            key = SETTINGS_TYPES.PAYMENT;
            break;
        case SETTINGS_TYPES.CRM:
            key = SETTINGS_TYPES.CRM;
            break;
        default:
            key = SETTINGS_TYPES.GENERAL;
    }

    return key;
};
